import {makeVar} from "@apollo/client";
import type {BetWithDetails, BetMetaIds, BetMeta} from "@atg-tillsammans/types/generated";
import type {HorseReceiptPushEvent} from "@atg-tillsammans/receipt-types";

export const receiptPushDataVar = makeVar<{
    [receiptId: string]: {
        event: HorseReceiptPushEvent;
        couponId?: string;
        receipt?: BetWithDetails;
        betMeta?: BetMeta;
        betMetaIds?: BetMetaIds;
    };
}>({});

export const setHorseReceiptPushData = ({
    event,
    receiptId,
    couponId,
    receipt,
    betMeta,
    betMetaIds,
}: {
    event: HorseReceiptPushEvent;
    receiptId: string;
    couponId?: string;
    receipt?: BetWithDetails;
    betMeta?: BetMeta;
    betMetaIds?: BetMetaIds;
}) =>
    receiptPushDataVar({
        ...receiptPushDataVar(),
        [receiptId]: {
            event,
            receipt,
            couponId,
            betMeta,
            betMetaIds,
        },
    });
